import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <path
      className="cls-1"
      d="M245,101.3c-1.4-6.6-5.2-12.8-9.3-18.3,0,0-13.8-33.5-32.2-44-18.3-10.5-71.5-16.5-71.5-16.5-12.7-2.2-46.2,4.7-56.4,7.8-20.4,4.2-33.7,19.8-44.2,36.7-16.8,27.2-23.9,58.8-18.3,89.3.7,4,1.8,7.8,3.1,11.5l4.4-1.8,7.5-3.7c.3.2,0,0-.2-.1l-8.9.6c-.2-1.8.2-3.3.5-5,1.3-6.2,2.7-12.3,4.4-18.4l2.6-8.2,2.6-7c1.5-3.8,3.4-7.2,5.8-10.6.1-.3,0-.4-.1-.1-5.1,5.1-8.5,11.2-11.2,17.8-.5.2-.3.6-.5,1l-3.3,10.2-.4,2.5c0,.1-.4.1-.3,0,.2-1.2-.2-2.2,0-3.8,2.9-16.7,7.1-30.1,18.3-43.2,8.8-10.3,19.3-18,31.4-24.4l-5.1-.4c13.7-8.6,31.9-14.4,47.8-16.5l7.5-1-6.6-1.2c15.2-3.6,33.1-2.6,47.2,4.6,9.2-3.4,15.8-7.9,23.1-14.3.6-.6,1.4-1.1,2.2-1.3,1-.3,1.9.6,2.1,1.5,1.3,4.8-1,10.9-2.9,15.6,0,.1-.1.5,0,.4l.4-.2c2.4-1.3,4.6-2.5,6.8-4.1,1.8-1.2,4.1-3.4,5.5-2.6,1.2.7.9,4.1.3,6.1-1.9,6.5-5.4,12.3-10.3,17.1,2,2.9,3.5,5.9,4.7,9.2l.5,1.6c1.1,3.4,1.9,6.9,2.2,10.6l1.2,12.2c1,9.8,2.7,19.3,5.7,28.6,2.2,6.7,4.7,13.1,7.6,19.5,1.7,3.7,3.4,7.9,4.1,11.9v2.5c-.3,1.9-.9,3.7-2,5.5-3,4.7-6.4,8.9-10.4,12.8-4.4,4.3-8.8,2.2-13.5-.7-5.7.2-11.9-1.1-15.2-5.9-1.4-2-1.9-4.4-2.1-6.8l-.4-7.2c-.5-4.5-2.5-8.4-5.9-11.4l-.2-.3c-2.4-2-4.8-3.5-7.5-4.7l-7.5-3.4c-3.7-1.6-7-3.7-9.9-6.5-3.8-3.6-6-8.3-6.1-13.6v-5.9c-3.3,2.7-5.3,6.3-5.9,10.6-1.1,8.1.8,16.4,2.9,24.3,2.3,8.7,5,17.2,7.8,25.8l4.3,13.2c1.6,4.8,2.7,9.5,3.6,14.5.4,2.3.7,4.5.9,6.8,11.6-.5,23.1-1.7,32.4-4.1,13.8-3.6,25.8-11.3,37-19.6,13.7-10.2,21.4-24.2,23.5-40,.2-1.2.3-2.5.5-3.7,3.2-10.3,4.6-21.1,5.6-31.8.6-6.7,1.6-13.5.2-20.1Z"
    />
    <path
      className="cls-1"
      d="M178.7,99c3.4,2.3,2.4,6.2,4.8,8.4,2.4-2.9,2.1-5.7,1.3-8.8-.9-3.4-4.2-5.8-7.8-5.9-5.2,0-10.1,5.3-8.8,9.8l5-3.5c1.3-.9,4.4-.9,5.6,0Z"
    />
  </svg>
);
export default SVGComponent;
